import React from "react";
import Page from "components/Page";
import { Props } from "./SiteCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const SiteCustomTypes = lazyWithRetry(() => import("./SiteCustomTypes"));

export default (props: Props) => (
  <Page>
    <SiteCustomTypes {...props} />
  </Page>
);
